import {ApplicationRef, Injectable} from '@angular/core';
import {SwUpdate, VersionReadyEvent} from '@angular/service-worker';
import {interval, ReplaySubject} from 'rxjs';
import {filter, map, startWith, switchMap} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class UpdateService {
  private _updateAvailable$ = new ReplaySubject<boolean>(1);
  readonly updateAvailable$ = this._updateAvailable$.asObservable();

  constructor(private swUpdate: SwUpdate, appRef: ApplicationRef) {
    if (!this.swUpdate.isEnabled) return;

    this.swUpdate.versionUpdates.pipe(
      filter((e): e is VersionReadyEvent => e.type === 'VERSION_READY'),
      map(() => true)
    ).subscribe(this._updateAvailable$);

    if (this.swUpdate.isEnabled) {
      appRef.isStable.pipe(
        filter(Boolean),
        switchMap(() =>
          // check every 6 hours, only if online
          interval(6 * 60 * 60 * 1000).pipe(
            startWith(0),
            filter(() => navigator.onLine)
          )
        )
      ).subscribe(() => {
        this.swUpdate.checkForUpdate().catch();
      });
    }
  }

  async activateAndReload() {
    await this.swUpdate.activateUpdate();
    document.location.reload();
  }
}
